const _excluded = ["children", "renderSideNavigation", "renderTopNavigation", "renderAboveLayout"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import SideNavigation from '@adsk/alloy-side-navigation';
import TopNavigation from '@adsk/alloy-top-navigation';
import SideNavigationLayout from './SideNavigationLayout';
import TopNavigationLayout from './TopNavigationLayout';

/**
 * Skeleton for page navigation frame, housing navigation components.
 */
const NavigationLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      renderSideNavigation,
      renderTopNavigation,
      renderAboveLayout
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TopNavigationLayout, _extends({}, props, {
    ref: ref,
    renderTopNavigation: renderTopNavigation,
    renderAboveLayout: renderAboveLayout
  }), /*#__PURE__*/React.createElement(SideNavigationLayout, {
    renderSideNavigation: renderSideNavigation
  }, children));
});
NavigationLayout.displayName = 'NavigationLayout';
NavigationLayout.defaultProps = {
  renderSideNavigation: props => /*#__PURE__*/React.createElement(SideNavigation, props),
  renderTopNavigation: props => /*#__PURE__*/React.createElement(TopNavigation, props)
};
NavigationLayout.propTypes = {
  /** Page content */
  children: PropTypes.node,
  /** Side navigation render function */
  renderSideNavigation: PropTypes.func,
  /** Top navigation render function */
  renderTopNavigation: PropTypes.func,
  /** Items that will render above the layout*/
  renderAboveLayout: PropTypes.func
};
export default NavigationLayout;
//# sourceMappingURL=NavigationLayout.js.map